import { useEffect, useState } from 'react';
import { get } from 'lodash';
import { Controller, useForm } from 'react-hook-form';
import InputField from '../../../Common/InputField';
import CheckboxField from '../../../Common/CheckboxField';
import { Grid, Button, IconButton } from '@mui/material';
import TicketCharter from '../../Ticket-Notes/TicketCharter';
import DateField from '../../../Common/DateField';
import { State, City } from 'country-state-city';
import PhoneInput from 'react-phone-number-input/react-hook-form-input';
import { subDepartmentOptions } from '../../../Fields/subDepartmentOptions.js';
import {
  isValidPhoneNumber,
  isPossiblePhoneNumber,
} from 'react-phone-number-input';
import {
  postRequest,
  putRequest,
  getRequest,
} from '../../interceptor/interceptor';
import FullScreenLoader from '../../Loader/FullScreenLoader';
import {
  UPDATE_TTD_REQ,
  ADD_TTD_REQ,
  REQ_ID,
  REFERRAL_DATA_BY_CONTACT,
  TTD_DATES,
  GET_MANDALS,
  ASSIGNED_TO,
  GET_VILLAGES,
  GET_CONSTITUENCIES,
  GET_DISTRICTS,
} from '../../../apiConst';
import { useLocation, useNavigate } from 'react-router';
import SelectDropdown from '../../../Common/SelectDropdown';
import {
  grievanceApplicantFields,
  referalFields,
  grievanceRequestFields,
  dataEntryGrievanceTicketFields,
  requestFields,
  approvalActionFields,
} from '../../../Fields/ttdFields';
import {
  grievanceApplicantFieldsTelugu,
  referalFieldsTelugu,
  grievanceRequestFieldsTelugu,
  dataEntryGrievanceTicketFieldsTelugu,
  requestFieldsTelugu,
} from '../../../Fields/ttdFieldsTelugu.js';
import CkEditorComponent from '../../../Common/CkEditor';
import moment from 'moment';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import BackButton from '../../../Common/BackButton.jsx';

const AddTtd = () => {
  const { role, designation, firstName } = useSelector((state) => state.user);
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const fields = [
    ...dataEntryGrievanceTicketFields,
    ...grievanceApplicantFields,
    ...grievanceRequestFields,
  ];
  const [id, setId] = useState(null);
  const [isDisabledTicket, setIsDisabledTicket] = useState(false);
  const [ttdReqNo, setTtdReqNo] = useState(
    location?.state?.data?.task?.ttdReqNo || null
  );
  const [isEdit, setIsEdit] = useState(null);
  const [requestDetails, setRequestDetails] = useState(false);
  const [contactDetails, setContactDetails] = useState(false);
  const [detailsKnown, setDetailsKnown] = useState(false);
  const [other, setOther] = useState('');
  const [qualification, setQualification] = useState('');
  const [currentLocation, setCurrentLocation] = useState('');
  const [requestedLocation, setRequestedLocation] = useState('');
  const [referral, setReferral] = useState(false);
  const [ticket, setTicket] = useState(null);
  const [disableAllFields, setDisableAllFields] = useState(false);
  const [ttdDatesApproved, setTtdDatesApproved] = useState([]);
  const [ttdDatesInProgress, setTtdDatesInProgress] = useState([]);
  const [minDate, setMinDate] = useState('');
  const [issueOpen, setIssueOpen] = useState(moment().format('YYYY-MM-DD'));
  const [targetResolution, setTargetResolution] = useState(
    moment().format('YYYY-MM-DD')
  );

  const selectedTtdDate = moment(location.state?.date).format('YYYY-MM-DD');

  const [states, setStates] = useState([]);
  const [state, setState] = useState('');
  const [district, setDistrict] = useState('');
  const [constituency, setConstituency] = useState('');
  const [constituencies, setConstituencies] = useState('');
  const [mandal, setMandal] = useState('');
  const [mandals, setMandals] = useState([]);
  const [village, setVillage] = useState('');
  const [villages, setVillages] = useState([]);
  const [cities, setCities] = useState([]);
  const [refType, setRefType] = useState('');
  const [assignedTo, setAssignedTo] = useState([]);

  const [referralType, setRefferalType] = useState([
    { label: 'Self', value: 'self' },
    { label: 'TDP Cadre', value: 'tdpCadre' },
    { label: 'Janasena Cadre', value: 'janasenaCadre' },
    { label: 'BJP Cadre', value: 'bjpCadre' },
    { label: 'Other', value: 'other' },
  ]);
  const [referralMode, setRefferalMode] = useState([
    { label: 'Letter', value: 'letter' },
    { label: 'Phone Call', value: 'phoneCall' },
    { label: 'Text Message', value: 'textMessage' },
    { label: 'In Person', value: 'inPerson' },
  ]);

  const [priority, setPriority] = useState([
    { label: 'High', value: 'high' },
    { label: 'Low', value: 'low' },
    { label: 'Medium', value: 'medium' },
  ]);

  const [requestType, setRequestType] = useState('');
  const [requestMode, setRequestMode] = useState('');
  const [personalRequestType, setPersonalRequestType] = useState('');
  const [stateDepartment, setStateDepartment] = useState('');
  const [centralDepartment, setCentralDepartment] = useState('');
  const [ttdAvailableSlot, setTtdAvailableSlot] = useState('');
  const [medicalRequestType, setMedicalRequestType] = useState('');
  const [communityRequestDepartment, setCommunityRequestDepartment] =
    useState('');

  const [isTicketToggle, setIsTicketToggle] = useState(true); // State to toggle the accordion
  const [isApplicantToggle, setIsApplicantToggle] = useState(true); // State to toggle the accordion
  const [isRequestToggle, setIsRequestToggle] = useState(true); // State to toggle the accordion
  const [isRefferalToggle, setIsRefferalToggle] = useState(true); // State to toggle the accordion
  const [privateRequestType, setPrivateRequestType] = useState('');
  const [employmentRequestType, setEmploymentRequestType] = useState('');
  const [isAssignedToggle, setIsAssignedToggle] = useState(true);

  const ticketToggleAccordion = () => {
    setIsTicketToggle(!isTicketToggle);
    // setIsApplicantToggle(false);
    // setIsRequestToggle(false);
    // setIsRefferalToggle(false);
  };
  const applicantToggleAccordion = () => {
    setIsApplicantToggle(!isApplicantToggle);
    // setIsRequestToggle(false);
    // setIsRefferalToggle(false);
    // setIsTicketToggle(false);
  };
  const requestToggleAccordion = () => {
    setIsRequestToggle(!isRequestToggle);
    // setIsRefferalToggle(false);
    // setIsTicketToggle(false);
    // setIsApplicantToggle(false);
  };
  const refferalToggleAccordion = () => {
    setIsRefferalToggle(!isRefferalToggle);
    // setIsApplicantToggle(false);
    // setIsRequestToggle(false);
    // setIsTicketToggle(false);
  };

  const assignedToggleAccordion = () => {
    setIsAssignedToggle(!isAssignedToggle);
  };
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    getValues,
    control,
    formState: { errors },
  } = useForm({});

  const emailValidation = {
    validate: (value) => {
      if (!value) return true;
      const emails = value.split(/[\s,]+/);
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return (
        emails.every((email) => emailRegex.test(email)) ||
        'Please enter valid email addresses separated by commas or spaces'
      );
    },
  };

  useEffect(() => {
    if (location?.state?.isEdit || location?.state?.isView) {
      location?.state?.isEdit && setIsEdit(location?.state?.isEdit);
      const { task } = location?.state?.data;
      console.log('task', task);

      // Set form fields using setValue
      fields.map((field) => setValue(field.fieldName, task[field.fieldName]));
      setTtdReqNo(task.ttdReqNo);
      setReferral(task.referral);
      setVillage(task?.village);
      setTtdAvailableSlot(task.ttdAvailableSlot);
      setValue('state', task?.state);
      setValue('district', task?.district);
      setValue('constituency', task?.constituency);
      setValue('mandal', task?.mandal);
      setValue('referralType', task?.referralType);
      setValue('referralContact', task?.referralContact);
      setValue('referralName', task?.referralName);
      setValue('referralDesignation', task?.referralDesignation);
      setValue('referralMode', task?.referralMode);
      setValue('ttdAvailableSlot', task?.ttdAvailableSlot);
    } else {
      // If neither edit nor view, generate unique ID or perform other logic
      getUniqueId();
      setValue('staffDesignation', designation);
      setValue('ticketCreatedBy', firstName);
      setValue(
        'ttdAvailableSlot',
        selectedTtdDate || moment().format('YYYY-MM-DD')
      );
    }
  }, []);

  useEffect(() => {
    if (ttdDatesInProgress.length === 0 && ttdDatesApproved.length === 0) {
      getExcludedDates();
    }
    fetchAssignedTo();
  }, []);

  useEffect(() => {
    let today = new Date();
    setMinDate(new Date(today.setDate(today.getDate() + 1)));
    const indiaStates = State.getStatesOfCountry('IN');
    setStates(indiaStates);
  }, []);

  useEffect(() => {
    if (location?.state?.isEdit && states.length > 0) {
      setValue('state', location?.state?.data?.task?.state);
      setState(location?.state?.data?.task?.state);
    }
  }, [states]);

  useEffect(() => {
    if (location?.state?.isEdit && cities.length > 0) {
      setValue('district', location?.state?.data?.task?.district);
      setDistrict(location?.state?.data?.task?.district);
    }
  }, [cities]);

  useEffect(() => {
    if (location?.state?.isEdit && constituencies.length > 0) {
      setValue('constituency', location?.state?.data?.task?.constituency);
      setConstituency(location?.state?.data?.task?.constituency);
    }
  }, [constituencies]);

  useEffect(() => {
    if (location?.state?.isEdit && mandals.length > 0) {
      setValue('mandal', location?.state?.data?.task?.mandal);
      setMandal(location?.state?.data?.task?.mandal);
    }
  }, [mandals]);

  useEffect(() => {
    if (location?.state?.isEdit && villages.length > 0) {
      setValue('village', location?.state?.data?.task?.village);
    }
  }, [villages]);

  // useEffect(() => {
  //   const indiaCities = City.getCitiesOfState('IN', state);
  //   const sortedCities = indiaCities.sort((a, b) => {
  //     if (a.name === 'Srikakulam') return -1;
  //     if (b.name === 'Srikakulam') return 1;
  //     return a.name.localeCompare(b.name);
  //   });
  //   setCities(sortedCities);
  // }, [state]);

  useEffect(() => {
    getCities(state);
  }, [state]);

  useEffect(() => {
    getConstituencies(district);
  }, [district]);

  useEffect(() => {
    getMandals(constituency);
  }, [constituency]);

  useEffect(() => {
    getVillages(mandal);
  }, [mandal]);

  const onCancel = () => {
    if (role === 'Grievance-Data-Entry-Operator') {
      navigate('/ttd-calendar/list', {});
    } else {
      navigate('/ttd-calendar/list', {});
    }
  };

  const fetchAssignedTo = async () => {
    await getRequest(`${ASSIGNED_TO}`).then((res) => {
      if (res) {
        console.log('🚀 ~ awaitgetRequest ~ es:', res);
        const options = [];
        res.forEach((item, index) => {
          options.push({
            label: item?.email,
            value: item?.email,
          });
        });
        setAssignedTo(options);
      }
    });
  };

  const getCities = (selectedState) => {
    if (selectedState !== 'AP') {
      const indiaCities = City.getCitiesOfState('IN', selectedState);

      setCities(indiaCities);
    } else {
      getRequest(`${GET_DISTRICTS}${selectedState}`)
        .then((res) => {
          console.log('res', res);
          const { data } = res;
          console.log('🚀 ~ .then ~ data:', data);
          if (data) {
            const sortedCities = data.sort((a, b) => {
              if (a.name === 'Srikakulam') return -1;
              if (b.name === 'Srikakulam') return 1;
              return a.name.localeCompare(b.name);
            });
            setCities(sortedCities);
          }
        })
        .catch((e) => {
          console.log('error getting districts', e);
          setCities([]);
        });
    }
  };

  const getConstituencies = (dis) => {
    getRequest(`${GET_CONSTITUENCIES}${dis}`)
      .then((res) => {
        console.log('res', res);
        const { data } = res;
        console.log('🚀 ~ .then ~ data:', data);
        if (data) {
          setConstituencies(data);
        }
      })
      .catch((e) => {
        console.log('error getting constituencies', e);
      });
  };

  const getMandals = (consti) => {
    getRequest(`${GET_MANDALS}${consti}`)
      .then((res) => {
        console.log('res', res);
        const { data } = res;
        console.log('🚀 ~ .then ~ data:', data);
        if (data) {
          setMandals(data);
        }
      })
      .catch((e) => {
        console.log('error getting mandals', e);
      });
  };

  const getVillages = (man) => {
    getRequest(`${GET_VILLAGES}${man}`)
      .then((res) => {
        console.log('res', res);
        const { data } = res;
        if (data) {
          setVillages(data);
        }
      })
      .catch((e) => {
        console.log('error getting mandals', e);
      });
  };

  const getUniqueId = () => {
    setIsLoading(true);
    getRequest(`${REQ_ID}?prefix=TTD`)
      .then((res) => {
        console.log('res', res);
        const { data } = res;
        if (data) {
          setValue('ttdReqNo', data);
          setTtdReqNo(data);
          setIsDisabledTicket(true);
          setIsLoading(false);
        } else {
          setIsLoading(true);
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const getExcludedDates = () => {
    let url = '';
    url = getRequest(`${TTD_DATES}`);
    url
      .then((res) => {
        setTtdDatesApproved(res.approved);
        setTtdDatesInProgress(res.inprogress);
      })
      .catch((error) => {
        console.log('error ttd', error);
      });
  };

  const onSubmit = async (data, e) => {
    // console.log('e', e.target.value);
    // console.log('data', data);
    let ccEmails = [];

    if (data?.ccEmail) {
      ccEmails = data.ccEmail
        .split(/[\s,]+/) // split by comma or whitespace
        .map((email) => email.trim()) // trim whitespace
        .filter((email) => email.length > 0); // remove empty strings if any
    }

    // console.log("🚀 ~ onSubmit ~ ccEmails:", ccEmails)

    setIsLoading(true);

    let phoneNumber = data?.applicantMobile;
    let referalNumber = data?.referralContact;

    if (referalNumber) {
      const isPhoneNumber = isValidPhoneNumber(phoneNumber);
      const isReferralContact = isValidPhoneNumber(referalNumber);
      if (!isPhoneNumber) {
        setIsLoading(false);
        return toast.error('Enter a valid applicant phone number!');
      } else if (!isReferralContact) {
        setIsLoading(false);
        return toast.error('Enter a valid referral phone number!');
      }
      if (e.target.value === 'submit') {
        data = {
          ...data,
          ccEmail: ccEmails,
          assignedTo: data?.assignedTo,
          priority: data?.priority,
          targetResolution: moment(data.targetResolution).format('YYYY-MM-DD'),
          issueOpen: moment(data.issueOpen).format('YYYY-MM-DD'),
          isStepperForm: false,
          isDraft: false,
        };

        let response;
        if (isEdit) {
          response = await putRequest(`${UPDATE_TTD_REQ}`, data);
        } else {
          response = await postRequest(`${ADD_TTD_REQ}`, data);
        }
        try {
          console.log('res', response);
          toast.success(response?.data?.message);
          setIsLoading(false);
          if (response?.data?.attachment?.url && response?.data?.ttdReqNo) {
            const pdfurl = response?.data?.attachment?.url;
            const link = document.createElement('a');
            link.href = pdfurl;
            link.setAttribute(
              'download',
              `${response?.data?.attachment?.url}.pdf`
            );
            document.body.appendChild(link);
            link.click();
          }
          if (
            role === 'Grievance-Data-Entry-Operator' &&
            response?.data?.message
          ) {
            setIsLoading(false);
            reset();
            getUniqueId();
          } else if (response?.data?.message) {
            setIsLoading(false);
            reset();
            getUniqueId();
          } else {
            setIsLoading(false);
          }
        } catch (error) {
          setIsLoading(false);
        }
      } else {
        data = {
          ...data,
          ccEmail: ccEmails,
          assignedTo: data?.assignedTo,
          priority: data?.priority,
          targetResolution: moment(data.targetResolution).format('YYYY-MM-DD'),
          issueOpen: moment(data.issueOpen).format('YYYY-MM-DD'),
          isStepperForm: false,
          isDraft: true,
        };

        let response;
        if (isEdit) {
          response = await putRequest(`${UPDATE_TTD_REQ}`, data);
        } else {
          response = await postRequest(`${ADD_TTD_REQ}`, data);
        }
        try {
          console.log('res', response);
          toast.info(response?.data?.message);
          setIsLoading(false);
          if (role === 'Grievance-Data-Entry-Operator') {
            reset();
            navigate('/ttd-calendar/list', {});
          } else {
            reset();
            navigate('/ttd-calendar/list', {});
          }
        } catch (error) {
          setIsLoading(false);
        }
      }
    } else {
      const isPhoneNumber = isValidPhoneNumber(phoneNumber);
      //const isReferralContact = isValidPhoneNumber(referalNumber);
      if (!isPhoneNumber) {
        setIsLoading(false);
        return toast.error('Enter a valid applicant phone number!');
      }

      if (e.target.value === 'submit') {
        data = {
          ...data,
          ccEmail: ccEmails,
          targetResolution: moment(data.targetResolution).format('YYYY-MM-DD'),
          issueOpen: moment(data.issueOpen).format('YYYY-MM-DD'),
          isStepperForm: false,
          isDraft: false,
        };

        let response;
        if (isEdit) {
          response = await putRequest(`${UPDATE_TTD_REQ}`, data);
        } else {
          response = await postRequest(`${ADD_TTD_REQ}`, data);
        }
        try {
          console.log('res', response);
          toast.info(response?.data?.message);
          setIsLoading(false);
          if (response?.data?.attachment?.url && response?.data?.ttdReqNo) {
            const pdfurl = response?.data?.attachment?.url;
            const link = document.createElement('a');
            link.href = pdfurl;
            link.setAttribute(
              'download',
              `${response?.data?.attachment?.url}.pdf`
            );
            document.body.appendChild(link);
            link.click();
          }
          if (
            role === 'Grievance-Data-Entry-Operator' &&
            response?.data?.message
          ) {
            setIsLoading(false);
            reset();
            getUniqueId();
          } else if (response?.data?.message) {
            setIsLoading(false);
            reset();
            getUniqueId();
          } else {
            setIsLoading(false);
          }
        } catch (error) {
          setIsLoading(false);
        }
      } else {
        data = {
          ...data,
          ccEmail: ccEmails,
          targetResolution: moment(data.targetResolution).format('YYYY-MM-DD'),
          issueOpen: moment(data.issueOpen).format('YYYY-MM-DD'),
          isStepperForm: false,
          isDraft: true,
        };

        let response;
        if (isEdit) {
          response = await putRequest(`${UPDATE_TTD_REQ}`, data);
        } else {
          response = await postRequest(`${ADD_TTD_REQ}`, data);
        }
        try {
          console.log('res', response);
          toast.info(response?.data?.message);
          setIsLoading(false);

          if (role === 'Grievance-Data-Entry-Operator') {
            reset();
            navigate('/ttd-calendar/list', {});
          } else {
            reset();
            navigate('/ttd-calendar/list', {});
          }
        } catch (error) {
          setIsLoading(false);
        }
      }
    }
  };

  const fetchReferralDetails = (contactNumber) => {
    setIsLoading(true);
    getRequest(`${REFERRAL_DATA_BY_CONTACT}${contactNumber}`)
      .then((res) => {
        if (res) {
          // Assuming the API response contains `referralName` and `referralDesignation`
          setValue('referralName', res.referralName || '');
          setValue('referralDesignation', res.referralDesignation || '');
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const handleBlur = (e) => {
    const contactNumber = '+91' + e.target.value.replace(/[^\d\+]/g, '');
    if (refType !== 'self' && contactNumber) {
      fetchReferralDetails(contactNumber);
    }
  };

  const conditionalFields = [
    {
      fieldName: 'ttdAvailableSlot',
      fieldTitle: 'TTD Available Slot*',
      fieldType: 'date',
    },
  ];

  const conditionalFieldsTelugu = [
    {
      fieldName: 'ttdAvailableSlot',
      fieldTitle: 'టీటీడీ స్లాట్*',
      fieldType: 'date',
    },
  ];

  const onPinCodeBlur = (e) => {
    console.log('e', e);
    const { value } = e.target;
    console.log('pincode++++11=+++', value);
    if (value) {
      fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?components=postal_code:${value}&key=${process.env.REACT_APP_GEOLOCATION_API}`
      )
        .then((response) => response.json())
        .then((res) => {
          if (res?.results && res?.results.length > 0) {
            const data = res.results[0];
            let obj = {};
            get(data, 'address_components').forEach((addr) => {
              if (get(addr, 'types').includes('locality')) {
                obj['city'] = get(addr, 'long_name');
              } else if (
                get(addr, 'types').includes('Administrative_area_level_3')
              ) {
                obj['city'] = get(addr, 'long_name');
              } else if (
                get(addr, 'types').includes('Administrative_area_level_1')
              ) {
                obj['state'] = get(addr, 'short_name');
              } else if (get(addr, 'types').includes('country')) {
                obj['country'] = get(addr, 'short_name');
              }
            });
            let countryVal = '';
            countryVal = obj.country;
            setStates(State.getStatesOfCountry(countryVal));
            let stateObj = obj.state === 'TS' ? 'TG' : obj.state;
            setCities(City.getCitiesOfState(countryVal, stateObj));
            setTimeout(() => {
              setValue('district', obj.city);
              setValue('state', stateObj);
            }, 500);
          }
        });
    }
  };

  return (
    <>
      <div className="block rounded-lg bg-white p-2 lg:pt-6 lg:pb-6 lg:pl-24 lg:pr-24 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] m-4 overflow-auto">
        <div className="flex flex-col lg:flex-row justify-between gap-2 mb-2">
          <BackButton onClick={() => navigate(-1)} />
          <label className="inline-flex items-center cursor-pointer">
            <span className="me-3 text-sm font-medium text-gray-900">
              English
            </span>
            <input
              type="checkbox"
              value=""
              className="sr-only peer"
              checked={checked}
              onChange={(e) => setChecked(e.target.checked)}
            />
            <div className="relative w-11 h-6 bg-gray-800 rounded-full peer peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
            <span className="ms-3 text-sm font-medium text-gray-900">
              తెలుగు
            </span>
          </label>
          <div className="flex mb-2 text-xl lg:text-2xl font-semibold text-gray-700 justify-end">
            {isEdit ? 'Update' : location?.state?.isView ? 'View' : ' '} TTD
            Darshan Request
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          {checked ? (
            <Grid container spacing={1}>
              {requestFieldsTelugu?.map((field) => {
                const {
                  fieldTitle,
                  fieldName,
                  fieldType,
                  validationObj,
                  options,
                } = field;

                return (
                  <>
                    <Grid item xs={12} lg={12} key={fieldName}>
                      <>
                        <label className="block text-gray-800 text-sm font-montsettat font-bold pr-4">
                          {fieldTitle}
                        </label>
                        <InputField
                          fieldName={fieldName}
                          validationObj={validationObj}
                          register={register}
                          disabled={
                            fieldName === 'ttdReqNo'
                              ? true
                              : location?.state?.isView
                          }
                          errors={errors}
                          fieldType={fieldType}
                        />
                      </>
                    </Grid>
                  </>
                );
              })}
            </Grid>
          ) : (
            <Grid container spacing={1}>
              {requestFields?.map((field) => {
                const {
                  fieldTitle,
                  fieldName,
                  fieldType,
                  validationObj,
                  options,
                } = field;

                return (
                  <>
                    <Grid item xs={12} lg={12} key={fieldName}>
                      <>
                        <label className="block text-gray-800 text-sm font-montsettat font-bold pr-4">
                          {fieldTitle}
                        </label>
                        <InputField
                          fieldName={fieldName}
                          validationObj={validationObj}
                          register={register}
                          disabled={
                            fieldName === 'ttdReqNo'
                              ? true
                              : location?.state?.isView
                          }
                          errors={errors}
                          fieldType={fieldType}
                        />
                      </>
                    </Grid>
                  </>
                );
              })}
            </Grid>
          )}

          <Grid container spacing={1}>
            <Grid item xs={12}>
              <div
                className="flex justify-between items-center text-white rounded-md bg-gray-700 p-2 mb-1 cursor-pointer"
                onClick={ticketToggleAccordion} // Toggle on click
              >
                <h2 className="font-montsettat">
                  {!checked ? 'Request Information' : 'అభ్యర్థన సమాచారం'}
                </h2>
                {/* Render the icon based on the toggle state */}
                {isTicketToggle ? <FaChevronUp /> : <FaChevronDown />}
              </div>
            </Grid>
            {!checked
              ? isTicketToggle &&
                dataEntryGrievanceTicketFields?.map((field) => {
                  const {
                    fieldTitle,
                    fieldName,
                    fieldType,
                    validationObj,
                    options,
                  } = field;

                  return (
                    <>
                      <Grid item xs={12} lg={3} key={fieldName}>
                        {fieldType === 'date' && fieldName === 'issueOpen' ? (
                          <>
                            <label className="block text-sm text-gray-800 font-bold pr-4">
                              {fieldTitle}
                            </label>
                            <DateField
                              fieldName={fieldName}
                              validationObj={validationObj}
                              control={control}
                              Controller={Controller}
                              minDate={new Date()}
                              onChange={(e) =>
                                setIssueOpen(
                                  moment(e.target.value).format('mm-dd-yyyy')
                                )
                              }
                              errors={errors}
                              defaultValue={getValues(fieldName)}
                              disabled={true}
                            />
                          </>
                        ) : fieldType === 'date' &&
                          fieldName === 'targetResolution' ? (
                          <>
                            <label className="block text-sm text-gray-800 font-bold pr-4">
                              {fieldTitle}
                            </label>
                            <DateField
                              fieldName={fieldName}
                              validationObj={validationObj}
                              control={control}
                              Controller={Controller}
                              minDate={issueOpen}
                              onChange={(e) =>
                                setTargetResolution(
                                  moment(e.target.value).format('mm-dd-yyyy')
                                )
                              }
                              readOnly
                              errors={errors}
                              defaultValue={getValues(fieldName)}
                              disabled={location?.state?.isView}
                            />
                          </>
                        ) : (
                          <>
                            <label className="block text-gray-800 text-sm font-bold pr-4">
                              {fieldTitle}
                            </label>
                            <InputField
                              fieldName={fieldName}
                              validationObj={validationObj}
                              register={register}
                              disabled={
                                fieldName === 'ttdReqNo'
                                  ? true
                                  : location?.state?.isView
                              }
                              errors={errors}
                              fieldType={fieldType}
                            />
                          </>
                        )}
                      </Grid>
                    </>
                  );
                })
              : isTicketToggle &&
                dataEntryGrievanceTicketFieldsTelugu?.map((field) => {
                  const {
                    fieldTitle,
                    fieldName,
                    fieldType,
                    validationObj,
                    options,
                  } = field;

                  return (
                    <>
                      <Grid item xs={12} lg={3} key={fieldName}>
                        {fieldType === 'date' && fieldName === 'issueOpen' ? (
                          <>
                            <label className="block text-sm text-gray-800 font-bold pr-4">
                              {fieldTitle}
                            </label>
                            <DateField
                              fieldName={fieldName}
                              validationObj={validationObj}
                              control={control}
                              Controller={Controller}
                              minDate={new Date()}
                              onChange={(e) =>
                                setIssueOpen(
                                  moment(e.target.value).format('mm-dd-yyyy')
                                )
                              }
                              errors={errors}
                              defaultValue={getValues(fieldName)}
                              disabled={true}
                            />
                          </>
                        ) : fieldType === 'date' &&
                          fieldName === 'targetResolution' ? (
                          <>
                            <label className="block text-sm text-gray-800 font-bold pr-4">
                              {fieldTitle}
                            </label>
                            <DateField
                              fieldName={fieldName}
                              validationObj={validationObj}
                              control={control}
                              Controller={Controller}
                              minDate={issueOpen}
                              onChange={(e) =>
                                setTargetResolution(
                                  moment(e.target.value).format('mm-dd-yyyy')
                                )
                              }
                              errors={errors}
                              defaultValue={getValues(fieldName)}
                              disabled={location?.state?.isView}
                            />
                          </>
                        ) : (
                          <>
                            <label className="block text-gray-800 text-sm font-bold pr-4">
                              {fieldTitle}
                            </label>
                            <InputField
                              fieldName={fieldName}
                              validationObj={validationObj}
                              register={register}
                              disabled={
                                fieldName === 'ttdReqNo'
                                  ? true
                                  : location?.state?.isView
                              }
                              errors={errors}
                              fieldType={fieldType}
                            />
                          </>
                        )}
                      </Grid>
                    </>
                  );
                })}
          </Grid>

          <Grid container spacing={1}>
            <Grid item xs={12}>
              <div
                className="flex justify-between items-center text-white rounded-md bg-gray-700 p-2 mb-1 cursor-pointer"
                onClick={applicantToggleAccordion} // Toggle on click
              >
                <h2 className="font-montsettat">
                  {!checked ? 'Applicant Information' : 'దరఖాస్తుదారు సమాచారం'}
                </h2>
                {/* Render the icon based on the toggle state */}
                {isApplicantToggle ? <FaChevronUp /> : <FaChevronDown />}
              </div>
            </Grid>
            {!checked
              ? isApplicantToggle &&
                grievanceApplicantFields?.map((field) => {
                  const {
                    fieldTitle,
                    fieldName,
                    fieldType,
                    validationObj,
                    options,
                  } = field;

                  return (
                    <Grid item xs={12} lg={3} key={fieldName}>
                      {fieldName === 'state' ? (
                        <>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {fieldTitle}
                          </label>
                          <SelectDropdown
                            fieldName="state"
                            options={states?.map((state) => ({
                              label: state?.name,
                              value: state?.isoCode,
                            }))}
                            register={register}
                            // validationObj={{
                            //   required: 'Please Select State',
                            // }}
                            onChange={(e) => setState(e.target.value)}
                            errors={errors}
                            disabled={location?.state?.isView}
                          />
                        </>
                      ) : fieldName === 'district' ? (
                        <>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {fieldTitle}
                          </label>
                          <SelectDropdown
                            fieldName="district"
                            options={cities?.map((city) => ({
                              label: city?.name,
                              value: city?.name,
                            }))}
                            register={register}
                            onChange={(e) => setDistrict(e.target.value)}
                            // validationObj={{
                            //   required: 'Please Select District',
                            // }}
                            errors={errors}
                            disabled={location?.state?.isView}
                          />
                        </>
                      ) : fieldName === 'constituency' ? (
                        <>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {fieldTitle}
                          </label>
                          {constituencies?.length > 0 ? (
                            <SelectDropdown
                              fieldName="constituency"
                              options={constituencies?.map(
                                (niyojakavargam) => ({
                                  label: niyojakavargam,
                                  value: niyojakavargam,
                                })
                              )}
                              register={register}
                              onChange={(e) => setConstituency(e.target.value)}
                              // validationObj={{
                              //   required: 'Please Select Mandal',
                              // }}
                              errors={errors}
                              disabled={location?.state?.isView}
                            />
                          ) : (
                            <InputField
                              fieldName="constituency"
                              validationObj={validationObj}
                              register={register}
                              disabled={location?.state?.isView}
                              errors={errors}
                              fieldType="text"
                            />
                          )}
                        </>
                      ) : fieldName === 'mandal' ? (
                        <>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {fieldTitle}
                          </label>
                          {constituencies?.length > 0 && mandals?.length > 0 ? (
                            <SelectDropdown
                              fieldName="mandal"
                              options={mandals?.map((mandalam) => ({
                                label: mandalam,
                                value: mandalam,
                              }))}
                              register={register}
                              onChange={(e) => setMandal(e.target.value)}
                              // validationObj={{
                              //   required: 'Please Select Mandal',
                              // }}
                              errors={errors}
                              disabled={location?.state?.isView}
                            />
                          ) : (
                            <InputField
                              fieldName="mandal"
                              validationObj={validationObj}
                              register={register}
                              disabled={location?.state?.isView}
                              errors={errors}
                              fieldType="text"
                            />
                          )}
                        </>
                      ) : fieldName === 'village' ? (
                        <>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {fieldTitle}
                          </label>
                          {constituencies?.length &&
                          mandals.length > 0 &&
                          villages?.length > 0 ? (
                            <SelectDropdown
                              fieldName="village"
                              options={villages?.map((gramam) => ({
                                label: gramam,
                                value: gramam,
                              }))}
                              register={register}
                              // validationObj={{
                              //   required: 'Please Select Village',
                              // }}
                              errors={errors}
                              onChange={(e) => setVillage(e.target.value)}
                              disabled={location?.state?.isView}
                            />
                          ) : (
                            <InputField
                              fieldName="village"
                              validationObj={validationObj}
                              register={register}
                              disabled={location?.state?.isView}
                              errors={errors}
                              fieldType="text"
                            />
                          )}
                        </>
                      ) : fieldName === 'applicantMobile' ? (
                        <>
                          <label className="block text-gray-800 text-sm font-bold pr-4">
                            {fieldTitle}
                          </label>
                          <PhoneInput
                            className="shadow appearance-none border border-solid border-gray-700 w-full py-2.5 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-blue-500 disabled:bg-gray-200"
                            country="IN"
                            name={fieldName}
                            defaultValue={getValues(fieldName)}
                            control={control}
                            id={fieldName}
                            rules={{
                              validate: (value) =>
                                isPossiblePhoneNumber(`${value}`),
                            }}
                            placeholder="Phone Number"
                            disabled={location?.state?.isView}
                          />
                          {errors[fieldName] && (
                            <p className="py-2 text-red-900">
                              Enter Valid Phone Number
                            </p>
                          )}
                        </>
                      ) : (
                        <>
                          <label className="block text-gray-800 text-sm font-bold pr-4">
                            {fieldTitle}
                          </label>
                          <InputField
                            fieldName={fieldName}
                            validationObj={validationObj}
                            register={register}
                            disabled={
                              fieldName === 'ttdReqNo'
                                ? true
                                : location?.state?.isView
                            }
                            onBlur={fieldName === 'pincode' && onPinCodeBlur}
                            errors={errors}
                            fieldType={fieldType}
                          />
                        </>
                      )}
                    </Grid>
                  );
                })
              : isApplicantToggle &&
                grievanceApplicantFieldsTelugu?.map((field) => {
                  const {
                    fieldTitle,
                    fieldName,
                    fieldType,
                    validationObj,
                    options,
                  } = field;

                  return (
                    <Grid item xs={12} lg={3} key={fieldName}>
                      {fieldName === 'state' ? (
                        <>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {fieldTitle}
                          </label>
                          <SelectDropdown
                            fieldName="state"
                            options={states?.map((state) => ({
                              label: state?.name,
                              value: state?.isoCode,
                            }))}
                            register={register}
                            // validationObj={{
                            //   required: 'Please Select State',
                            // }}
                            onChange={(e) => setState(e.target.value)}
                            errors={errors}
                            disabled={location?.state?.isView}
                          />
                        </>
                      ) : fieldName === 'district' ? (
                        <>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {fieldTitle}
                          </label>
                          <SelectDropdown
                            fieldName="district"
                            options={cities?.map((city) => ({
                              label: city?.name,
                              value: city?.name,
                            }))}
                            register={register}
                            onChange={(e) => setDistrict(e.target.value)}
                            // validationObj={{
                            //   required: 'Please Select District',
                            // }}
                            errors={errors}
                            disabled={location?.state?.isView}
                          />
                        </>
                      ) : fieldName === 'constituency' ? (
                        <>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {fieldTitle}
                          </label>
                          {constituencies?.length > 0 ? (
                            <SelectDropdown
                              fieldName="constituency"
                              options={constituencies?.map(
                                (niyojakavargam) => ({
                                  label: niyojakavargam,
                                  value: niyojakavargam,
                                })
                              )}
                              register={register}
                              onChange={(e) => setConstituency(e.target.value)}
                              // validationObj={{
                              //   required: 'Please Select Mandal',
                              // }}
                              errors={errors}
                              disabled={location?.state?.isView}
                            />
                          ) : (
                            <InputField
                              fieldName="constituency"
                              validationObj={validationObj}
                              register={register}
                              disabled={location?.state?.isView}
                              errors={errors}
                              fieldType="text"
                            />
                          )}
                        </>
                      ) : fieldName === 'mandal' ? (
                        <>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {fieldTitle}
                          </label>
                          {constituencies?.length && mandals?.length > 0 ? (
                            <SelectDropdown
                              fieldName="mandal"
                              options={mandals?.map((mandalam) => ({
                                label: mandalam,
                                value: mandalam,
                              }))}
                              register={register}
                              onChange={(e) => setMandal(e.target.value)}
                              // validationObj={{
                              //   required: 'Please Select Mandal',
                              // }}
                              errors={errors}
                              disabled={location?.state?.isView}
                            />
                          ) : (
                            <InputField
                              fieldName="mandal"
                              validationObj={validationObj}
                              register={register}
                              disabled={location?.state?.isView}
                              errors={errors}
                              fieldType="text"
                            />
                          )}
                        </>
                      ) : fieldName === 'village' ? (
                        <>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {fieldTitle}
                          </label>
                          {constituencies?.length &&
                          mandals.length > 0 &&
                          villages?.length > 0 ? (
                            <SelectDropdown
                              fieldName="village"
                              options={villages?.map((gramam) => ({
                                label: gramam,
                                value: gramam,
                              }))}
                              register={register}
                              // validationObj={{
                              //   required: 'Please Select Village',
                              // }}
                              errors={errors}
                              disabled={location?.state?.isView}
                            />
                          ) : (
                            <InputField
                              fieldName="village"
                              validationObj={validationObj}
                              register={register}
                              disabled={location?.state?.isView}
                              errors={errors}
                              fieldType="text"
                            />
                          )}
                        </>
                      ) : fieldName === 'applicantMobile' ? (
                        <>
                          <label className="block text-gray-800 text-sm font-bold pr-4">
                            {fieldTitle}
                          </label>
                          <PhoneInput
                            className="shadow appearance-none border border-solid border-gray-700 w-full py-2.5 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-blue-500 disabled:bg-gray-200"
                            country="IN"
                            name={fieldName}
                            defaultValue={getValues(fieldName)}
                            control={control}
                            id={fieldName}
                            rules={{
                              validate: (value) =>
                                isPossiblePhoneNumber(`${value}`),
                            }}
                            placeholder="Phone Number"
                            disabled={location?.state?.isView}
                          />
                          {errors[fieldName] && (
                            <p className="py-2 text-red-900">
                              Enter Valid Phone Number
                            </p>
                          )}
                        </>
                      ) : (
                        <>
                          <label className="block text-gray-800 text-sm font-bold pr-4">
                            {fieldTitle}
                          </label>
                          <InputField
                            fieldName={fieldName}
                            validationObj={validationObj}
                            register={register}
                            disabled={
                              fieldName === 'ttdReqNo'
                                ? true
                                : location?.state?.isView
                            }
                            onBlur={fieldName === 'pincode' && onPinCodeBlur}
                            errors={errors}
                            fieldType={fieldType}
                          />
                        </>
                      )}
                    </Grid>
                  );
                })}
            {checked && isApplicantToggle && village === 'other' ? (
              <Grid item xs={12} lg={3}>
                <label className="block text-sm text-gray-800 font-bold pr-4">
                  ఇతరాలు
                </label>
                <InputField
                  fieldName="applicantMiscellaneous"
                  register={register}
                  disabled={location?.state?.isView}
                  errors={errors}
                  fieldType="text"
                />
              </Grid>
            ) : !checked && isApplicantToggle && village === 'other' ? (
              <Grid item xs={12} lg={3}>
                <label className="block text-sm text-gray-800 font-bold pr-4">
                  Miscellaneous
                </label>
                <InputField
                  fieldName="applicantMiscellaneous"
                  register={register}
                  disabled={location?.state?.isView}
                  errors={errors}
                  fieldType="text"
                />
              </Grid>
            ) : null}
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <div
                className="flex justify-between items-center text-white rounded-md bg-gray-700 p-2 mb-1 cursor-pointer"
                onClick={requestToggleAccordion} // Toggle on click
              >
                <h2 className="font-montsettat">
                  {!checked ? 'Request Details' : 'అభ్యర్థన వివరాలు'}
                </h2>
                {/* Render the icon based on the toggle state */}
                {isRequestToggle ? <FaChevronUp /> : <FaChevronDown />}
              </div>
            </Grid>

            <>
              {!checked
                ? isRequestToggle &&
                  grievanceRequestFields
                    .filter((field) => field.fieldName === 'requestDescription')
                    .map((field) => {
                      const {
                        fieldTitle,
                        fieldName,
                        fieldType,
                        validationObj,
                      } = field;

                      return (
                        <Grid item xs={12} key={fieldName}>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {fieldTitle}
                          </label>
                          <InputField
                            fieldName={fieldName}
                            validationObj={validationObj}
                            register={register}
                            errors={errors}
                            fieldType={fieldType}
                            val={getValues(fieldName)}
                            disabled={location?.state?.isView}
                          />
                        </Grid>
                      );
                    })
                : isRequestToggle &&
                  grievanceRequestFieldsTelugu
                    .filter((field) => field.fieldName === 'requestDescription')
                    .map((field) => {
                      const {
                        fieldTitle,
                        fieldName,
                        fieldType,
                        validationObj,
                      } = field;

                      return (
                        <Grid item xs={12} key={fieldName}>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {fieldTitle}
                          </label>
                          <InputField
                            fieldName={fieldName}
                            validationObj={validationObj}
                            register={register}
                            errors={errors}
                            fieldType={fieldType}
                            val={getValues(fieldName)}
                            disabled={location?.state?.isView}
                          />
                        </Grid>
                      );
                    })}
            </>

            {!checked
              ? isRequestToggle &&
                grievanceRequestFields
                  .filter(
                    (field) =>
                      field.fieldName !== 'additionalInformation' &&
                      field.fieldName !== 'requestDescription'
                  )
                  .map((field) => {
                    const {
                      fieldTitle,
                      fieldName,
                      fieldType,
                      validationObj,
                      options,
                    } = field;

                    return (
                      <Grid item xs={12} lg={3} key={fieldName}>
                        {fieldType === 'date' ? (
                          <>
                            <label className="block text-sm text-gray-800 font-bold pr-4">
                              {fieldTitle}
                            </label>
                            <DateField
                              fieldName={fieldName}
                              validationObj={validationObj}
                              control={control}
                              Controller={Controller}
                              minDate={new Date()}
                              errors={errors}
                              defaultValue={getValues(fieldName)}
                              disabled={location?.state?.isView}
                            />
                          </>
                        ) : fieldType === 'editor' ? (
                          <>
                            <label className="block text-sm text-gray-800 font-bold pr-4">
                              {fieldTitle}
                            </label>
                            <CkEditorComponent
                              register={register}
                              fieldName={fieldName}
                              control={control}
                              data={getValues(fieldName) || ''}
                              setValue={setValue}
                              disabled={location?.state?.isView}
                            />
                          </>
                        ) : fieldType === 'select' ? (
                          <>
                            <label className="block text-sm text-gray-800 font-bold pr-4">
                              {fieldTitle}
                            </label>
                            <SelectDropdown
                              fieldName={fieldName}
                              options={options}
                              register={register}
                              // validationObj={{
                              //   required: 'Please Select Request Node',
                              // }}
                              onChange={(e) => setRequestMode(e.target.value)}
                              errors={errors}
                              val={getValues(fieldName)}
                              disabled={location?.state?.isView}
                            />
                          </>
                        ) : (
                          <>
                            <label className="block text-sm text-gray-800 font-bold pr-4">
                              {fieldTitle}
                            </label>
                            <InputField
                              fieldName={fieldName}
                              validationObj={validationObj}
                              register={register}
                              disabled={
                                fieldName === 'ttdReqNo'
                                  ? true
                                  : location?.state?.isView
                              }
                              errors={errors}
                              fieldType={fieldType}
                            />
                          </>
                        )}
                      </Grid>
                    );
                  })
              : isRequestToggle &&
                grievanceRequestFieldsTelugu
                  .filter(
                    (field) =>
                      field.fieldName !== 'additionalInformation' &&
                      field.fieldName !== 'requestDescription'
                  )
                  .map((field) => {
                    const {
                      fieldTitle,
                      fieldName,
                      fieldType,
                      validationObj,
                      options,
                    } = field;

                    return (
                      <Grid item xs={12} lg={3} key={fieldName}>
                        {fieldType === 'date' ? (
                          <>
                            <label className="block text-sm text-gray-800 font-bold pr-4">
                              {fieldTitle}
                            </label>
                            <DateField
                              fieldName={fieldName}
                              validationObj={validationObj}
                              control={control}
                              Controller={Controller}
                              minDate={new Date()}
                              errors={errors}
                              defaultValue={getValues(fieldName)}
                              disabled={location?.state?.isView}
                            />
                          </>
                        ) : fieldType === 'editor' ? (
                          <>
                            <label className="block text-sm text-gray-800 font-bold pr-4">
                              {fieldTitle}
                            </label>
                            <CkEditorComponent
                              register={register}
                              fieldName={fieldName}
                              control={control}
                              data={getValues(fieldName) || ''}
                              setValue={setValue}
                              disabled={location?.state?.isView}
                            />
                          </>
                        ) : fieldType === 'select' ? (
                       
                            <>
                              <label className="block text-sm text-gray-800 font-bold pr-4">
                                {fieldTitle}
                              </label>
                              <SelectDropdown
                                fieldName={fieldName}
                                options={options}
                                register={register}
                                // validationObj={{
                                //   required: 'Please Select Request Node',
                                // }}
                                onChange={(e) => setRequestMode(e.target.value)}
                                errors={errors}
                                val={getValues(fieldName)}
                                disabled={location?.state?.isView}
                              />
                            </>
                       
                        ) : (
                          <>
                            <label className="block text-sm text-gray-800 font-bold pr-4">
                              {fieldTitle}
                            </label>
                            <InputField
                              fieldName={fieldName}
                              validationObj={validationObj}
                              register={register}
                              disabled={
                                fieldName === 'ttdReqNo'
                                  ? true
                                  : location?.state?.isView
                              }
                              errors={errors}
                              fieldType={fieldType}
                            />
                          </>
                        )}
                      </Grid>
                    );
                  })}
            {isRequestToggle && (
              <Grid item xs={12} lg={3}>
                <>
                  <label className="block text-sm text-gray-800 font-bold pr-4">
                    {checked
                      ? conditionalFieldsTelugu[0].fieldTitle
                      : conditionalFields[0].fieldTitle}
                  </label>
                  <DateField
                    fieldName={conditionalFields[0].fieldName}
                    validationObj={conditionalFields[0].validationObj}
                    control={control}
                    Controller={Controller}
                    minDate={new Date()}
                    disabled={location?.state?.isView}
                    onChange={(e) =>
                      setTtdAvailableSlot(
                        moment(e.target.value).format('YYYY-MM-DD')
                      )
                    }
                    readOnly
                    excluded={ttdDatesApproved}
                    highlighted={ttdDatesInProgress}
                    errors={errors}
                    defaultValue={getValues(conditionalFields[0].fieldName)}
                  />
                </>
              </Grid>
            )}
            <>
              {!checked
                ? isRequestToggle &&
                  grievanceRequestFields
                    .filter(
                      (field) => field.fieldName === 'additionalInformation'
                    )
                    .map((field) => {
                      const {
                        fieldTitle,
                        fieldName,
                        fieldType,
                        validationObj,
                      } = field;

                      return (
                        <Grid item xs={12} lg={9} key={fieldName}>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {fieldTitle}
                          </label>
                          <InputField
                            fieldName={fieldName}
                            validationObj={validationObj}
                            register={register}
                            errors={errors}
                            fieldType={fieldType}
                            val={getValues(fieldName)}
                            disabled={location?.state?.isView}
                          />
                        </Grid>
                      );
                    })
                : isRequestToggle &&
                  grievanceRequestFieldsTelugu
                    .filter(
                      (field) => field.fieldName === 'additionalInformation'
                    )
                    .map((field) => {
                      const {
                        fieldTitle,
                        fieldName,
                        fieldType,
                        validationObj,
                      } = field;

                      return (
                        <Grid item xs={12} key={fieldName}>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {fieldTitle}
                          </label>
                          <InputField
                            fieldName={fieldName}
                            validationObj={validationObj}
                            register={register}
                            errors={errors}
                            fieldType={fieldType}
                            val={getValues(fieldName)}
                            disabled={location?.state?.isView}
                          />
                        </Grid>
                      );
                    })}
            </>
          </Grid>

          <Grid container spacing={1}>
            <Grid item xs={12}>
              <div
                className="flex justify-between items-center text-white rounded-md bg-gray-700 p-2 mb-1 cursor-pointer"
                onClick={refferalToggleAccordion} // Toggle on click
              >
                <h2 className="font-montsettat">
                  {!checked ? 'Referral Details' : 'రెఫరల్ వివరాలు'}
                </h2>
                {/* Render the icon based on the toggle state */}
                {isRefferalToggle ? <FaChevronUp /> : <FaChevronDown />}
              </div>
            </Grid>

            {!checked
              ? isRefferalToggle &&
                referalFields.map((field) => {
                  const {
                    fieldTitle,
                    fieldName,
                    fieldType,
                    validationObj,
                    options,
                  } = field;

                  return (
                    <Grid item xs={12} key={fieldName} lg={2.4}>
                      <label className="block text-sm text-gray-800 font-bold pr-4">
                        {fieldTitle}
                      </label>

                      {fieldType === 'select' ? (
                        <SelectDropdown
                          fieldName={fieldName}
                          register={register}
                          options={
                            fieldName === 'referralType'
                              ? referralType
                              : referralMode
                          }
                          onChange={(e) =>
                            fieldName === 'referralType' &&
                            setRefType(e.target.value)
                          }
                          validationObj={validationObj}
                          errors={errors}
                          disabled={location?.state?.isView}
                          val={getValues(
                            fieldName === 'referralType'
                              ? 'referralType'
                              : 'referralMode'
                          )}
                        />
                      ) : fieldName === 'referralContact' ? (
                        <>
                          {/* <label className="block text-gray-800 text-sm font-bold mb-3 pr-4">
                          {fieldTitle}
                        </label> */}
                          <PhoneInput
                            className="shadow appearance-none border border-solid border-gray-700 w-full py-2.5 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-blue-500 disabled:bg-gray-200"
                            country="IN"
                            name={fieldName}
                            defaultValue={getValues(fieldName)}
                            control={control}
                            placeholder="Phone Number"
                            id={fieldName}
                            onBlur={handleBlur}
                            rules={{
                              validate: (value) =>
                                isPossiblePhoneNumber(`${value}`),
                            }}
                            disabled={location?.state?.isView}
                          />
                          {errors[fieldName] && (
                            <p className="py-2 text-red-900">
                              Enter Valid Phone Number
                            </p>
                          )}
                        </>
                      ) : (
                        <InputField
                          fieldName={fieldName}
                          validationObj={validationObj}
                          register={register}
                          errors={errors}
                          fieldType={fieldType}
                          disabled={location?.state?.isView}
                          value={getValues(fieldName)}
                        />
                      )}
                    </Grid>
                  );
                })
              : isRefferalToggle &&
                referalFieldsTelugu.map((field) => {
                  const {
                    fieldTitle,
                    fieldName,
                    fieldType,
                    validationObj,
                    options,
                  } = field;

                  return (
                    <Grid item xs={12} key={fieldName} lg={2.4}>
                      <label className="block text-sm text-gray-800 font-bold pr-4">
                        {fieldTitle}
                      </label>

                      {fieldType === 'select' ? (
                        <SelectDropdown
                          fieldName={fieldName}
                          register={register}
                          options={
                            fieldName === 'referralType'
                              ? referralType
                              : referralMode
                          }
                          onChange={(e) =>
                            fieldName === 'referralType' &&
                            setRefType(e.target.value)
                          }
                          validationObj={validationObj}
                          errors={errors}
                          disabled={location?.state?.isView}
                          val={getValues(
                            fieldName === 'referralType'
                              ? 'referralType'
                              : 'referralMode'
                          )}
                        />
                      ) : fieldName === 'referralContact' ? (
                        <>
                          {/* <label className="block text-gray-800 text-sm font-bold mb-3 pr-4">
                          {fieldTitle}
                        </label> */}
                          <PhoneInput
                            className="shadow appearance-none border border-solid border-gray-700 w-full py-2.5 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-blue-500 disabled:bg-gray-200"
                            country="IN"
                            name={fieldName}
                            defaultValue={getValues(fieldName)}
                            control={control}
                            placeholder="Phone Number"
                            id={fieldName}
                            onBlur={handleBlur}
                            rules={{
                              validate: (value) =>
                                isPossiblePhoneNumber(`${value}`),
                            }}
                            disabled={location?.state?.isView}
                          />
                          {errors[fieldName] && (
                            <p className="py-2 text-red-900">
                              Enter Valid Phone Number
                            </p>
                          )}
                        </>
                      ) : (
                        <InputField
                          fieldName={fieldName}
                          validationObj={validationObj}
                          register={register}
                          errors={errors}
                          fieldType={fieldType}
                          disabled={location?.state?.isView}
                          value={getValues(fieldName)}
                        />
                      )}
                    </Grid>
                  );
                })}
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <div
                className="flex justify-between items-center text-white rounded-md bg-gray-700 p-2 mb-1 cursor-pointer"
                onClick={assignedToggleAccordion} // Toggle on click
              >
                <h2>For Office Use Only</h2>
                {/* Render the icon based on the toggle state */}
                {isAssignedToggle ? <FaChevronUp /> : <FaChevronDown />}
              </div>
            </Grid>
            {isAssignedToggle &&
              approvalActionFields.map((field) => {
                const {
                  fieldTitle,
                  fieldName,
                  fieldType,
                  validationObj,
                  options,
                } = field;

                return (
                  <Grid item xs={12} key={fieldName} lg={3}>
                    <label className="block text-sm text-gray-800 font-bold pr-4">
                      {fieldTitle}
                    </label>

                    {fieldType === 'select' && fieldName === 'priority' ? (
                      <SelectDropdown
                        fieldName={fieldName}
                        register={register}
                        options={priority}
                        validationObj={validationObj}
                        fieldType={fieldType}
                        errors={errors}
                        disabled={location?.state?.isView}
                      />
                    ) : fieldType === 'date' &&
                      fieldName === 'targetResolution' ? (
                      <>
                        <DateField
                          fieldName={fieldName}
                          validationObj={validationObj}
                          control={control}
                          Controller={Controller}
                          errors={errors}
                          defaultValue={getValues(fieldName)}
                          disabled={location?.state?.isView}
                        />
                      </>
                    ) : fieldType === 'text' && fieldName === 'ccEmail' ? (
                      <>
                        <InputField
                          fieldName={fieldName}
                          validationObj={emailValidation}
                          register={register}
                          errors={errors}
                          fieldType={fieldType}
                          disabled={location?.state?.isView}
                          value={getValues(fieldName)}
                        />
                      </>
                    ) : (
                      <SelectDropdown
                        fieldType={fieldType}
                        fieldName={fieldName}
                        register={register}
                        options={assignedTo}
                        validationObj={validationObj}
                        errors={errors}
                        disabled={location?.state?.isView}
                      />
                    )}
                  </Grid>
                );
              })}
          </Grid>

          <TicketCharter
            role={role}
            taskId={id}
            ttdReqNo={ttdReqNo}
            isView={location?.state?.isView}
            noteStatus="backlog"
            loc={window.location.pathname}
          />

          <hr />
          <div className="flex flex-col lg:flex-row items-center justify-center space-x-4">
            <Grid item>
              <Button
                variant="contained"
                color="error"
                onClick={onCancel}
                className="mt-5"
              >
                {location?.state?.isView ? 'Back' : 'Cancel'}
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="secondary"
                value="save"
                disabled={location?.state?.isView}
                onClick={handleSubmit(onSubmit)}
                className="mt-5"
              >
                {isEdit ? 'Update' : 'Save'}
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                // color="primary"
                type="submit"
                className="mt-5 bg-blueBg hover:blueBg"
                disabled={location?.state?.isView}
                value="submit"
                onClick={handleSubmit(onSubmit)}
              >
                Submit & Approve
              </Button>
            </Grid>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddTtd;
